<template>
  <div>
    <section>
      <div class="m_visual_wrap">
        <div class="container">
          <div class="main_search_wrap">
            <div class="main_search_box">
                <input
                  type="text"
                  class="m_int"
                  v-model="searchWord"
                  placeholder="Suffix or Model"
                  title="search"
                  autocomplete="off" 
                  @keydown.down="onKeyEventActive"
                  @keydown.up="onKeyEventActive"
                  @input="getSuggestList"
                  @keyup.enter="goSearchPageOrSetSearchword"
                />
                <ul v-if="this.suggestShow" @mouseleave="suggestShow=false"  class="autocomplete-ul">
                    <li class="autocomplete-li" :class="{ 'is-active': i === arrowCounter }" @mouseover="onMouseEventActive(i)" @click="selectSuggest(term)" v-for="(term,i) in suggestList" v-bind:key="i">{{term}}</li>
                </ul>
                <button type="button" @click="goSearchPageOrSetSearchword" class="m_search_bt">
                  <span>Search</span>
                </button>
            </div>
            <div class="toggle-box">
              <label class="toggle-switch">
                    <input type="checkbox" id="toggle" v-model="toggleCheck" @click="scrollUpAndDown">
                    <span class="slider"></span>
              </label>
            </div>
          </div>
        </div>
        <div class="main_quick_wrap">
          <div class="container">
            <div class="main_quick_inner m_mobile_quick">
              <carousel
                id="main_quick_slide"
                :items="1"
                :nav="true"
                class="owl-loaded"
                @initialize="fetchMainQbar()"
                v-if="prodQbarList.length != 0 && doctypeQbarList.length != 0"
              >
                <div class="owl-stage-outer">
                  <div
                    class="owl-stage"
                    style="
                      transform: translate3d(0px, 0px, 0px);
                      transition: all 0s ease 0s;
                      width: 1752px;
                    "
                  >
                    <div
                      class="owl-item"
                      v-bind:class="{ active: isFirst(index) }"
                      style="width: 876px"
                      v-for="(item, index) in prodQbarList"
                      :key="`a-${index}`"
                    >
                      <div class="item">
                        <div class="m_q_product_l">
                          <ul>
                            <li v-for="(item2, index2) in item" :key="`b-${index2}`">
                              <a
                                v-if="$session.get('token') != null"
                                :href="'/product/list?id=' + item2.prodId"
                                :style="
                                  'background: url(/prodType/img/' +
                                  item2.prodId +
                                  ') no-repeat 50% 20px;background-size : auto 70px;'
                                "
                                ><span>{{ item2.prodName }}</span></a
                              >
                              <a
                                v-else
                                href="/login"
                                :style="
                                  'background: url(/prodType/img/' +
                                  item2.prodId +
                                  ') no-repeat 50% 20px;background-size : auto 70px;'
                                "
                                ><span>{{ item2.prodName }}</span></a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      class="owl-item"
                      style="width: 876px"
                      v-for="(item, index) in doctypeQbarList"
                      :key="`c-${index}`"
                    >
                      <div class="item">
                        <div class="m_q_document_l">
                          <ul>
                            <li v-for="(item2, index2) in item" :key="`d-${index2}`">
                              <a
                                v-if="$session.get('token') != null"
                                :href="item2.doctypeId ? '/document/list?id=' + item2.doctypeId : '/symbollibrary' "
                                :style=" item2.doctypeId ?
                                  'background: url(/doctype/img/' +
                                  item2.doctypeId +
                                  ') no-repeat 50% 20px; background-size : auto 70px;'
                                  : ''
                                "
                                :class="!item2.doctypeId && 'Symbol Library'==item2.doctypeName? 'm_q_icon15' : '' "
                                ><span>{{ item2.doctypeName }}</span></a
                              >
                              <a
                                v-else
                                href="/login"
                                :style=" item2.doctypeId ?
                                  'background: url(/doctype/img/' +
                                  item2.doctypeId +
                                  ') no-repeat 50% 20px; background-size : auto 70px;'
                                  : ''
                                "
                                :class="!item2.doctypeId && 'Symbol Library'==item2.doctypeName? 'm_q_icon15' : '' "
                                ><span>{{ item2.doctypeName }}</span></a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-nav">
                  <button type="button" role="presentation" class="owl-prev disabled">
                    <span aria-label="Previous">‹</span>
                  </button>
                  <button type="button" role="presentation" class="owl-next">
                    <span aria-label="Next">›</span>
                  </button>
                </div>
                <div class="owl-dots">
                  <button role="button" class="owl-dot active">
                    <span></span>
                  </button>
                  <button role="button" class="owl-dot">
                    <span></span>
                  </button>
                </div>
              </carousel>
              <carousel
                id="main_quick_mobile"
                :items="1"
                :nav="true"
                class="owl-loaded owl-hidden"
                @initialize="fetchMainQbar()"
                v-if="prodQbarList2.length != 0 && doctypeQbarList2.length != 0"
              >
                <div class="owl-stage-outer">
                  <div
                    class="owl-stage"
                    style="
                      transform: translate3d(0px, 0px, 0px);
                      transition: all 0s ease 0s;
                      width: 1752px;
                    "
                  >
                    <div
                      class="owl-item"
                      v-bind:class="{ active: isFirst(index) }"
                      style="width: 876px"
                      v-for="(item, index) in prodQbarList2"
                      :key="`e-${index}`"
                    >
                      <div class="item">
                        <div class="m_q_product_l">
                          <ul>
                            <li v-for="(item2, index2) in item" :key="`f-${index2}`">
                              <a
                                v-if="$session.get('token') != null"
                                :href="'/product/list?id=' + item2.prodId"
                                :style="
                                  'background: url(/prodType/img/' +
                                  item2.prodId +
                                  ') no-repeat 50% 20px;background-size : auto 70px;'
                                "
                                ><span>{{ item2.prodName }}</span></a
                              >
                              <a
                                v-else
                                href="/login"
                                :style="
                                  'background: url(/prodType/img/' +
                                  item2.prodId +
                                  ') no-repeat 50% 20px;background-size : auto 70px;'
                                "
                                ><span>{{ item2.prodName }}</span></a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div
                      class="owl-item"
                      style="width: 876px"
                      v-for="(item, index) in doctypeQbarList2"
                      :key="`g-${index}`"
                    >
                      <div class="item">
                        <div class="m_q_document_l">
                          <ul>
                            <li v-for="(item2, index2) in item" :key="`h-${index2}`">
                              <a
                                v-if="$session.get('token') != null"
                                :href="item2.doctypeId ? '/document/list?id=' + item2.doctypeId : '/symbollibrary' "
                                :style=" item2.doctypeId ?
                                  'background: url(/doctype/img/' +
                                  item2.doctypeId +
                                  ') no-repeat 50% 20px; background-size : auto 70px;'
                                  : ''
                                "
                                :class="!item2.doctypeId && 'Symbol Library'==item2.doctypeName? 'm_q_icon15' : '' "
                                ><span>{{ item2.doctypeName }}</span></a
                              >
                              <a
                                v-else
                                href="/login"
                                :style=" item2.doctypeId ?
                                  'background: url(/doctype/img/' +
                                  item2.doctypeId +
                                  ') no-repeat 50% 20px; background-size : auto 70px;'
                                  : ''
                                "
                                :class="!item2.doctypeId && 'Symbol Library'==item2.doctypeName? 'm_q_icon15' : '' "
                                ><span>{{ item2.doctypeName }}</span></a
                              >
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-nav">
                  <button type="button" role="presentation" class="owl-prev disabled">
                    <span aria-label="Previous">‹</span>
                  </button>
                  <button type="button" role="presentation" class="owl-next">
                    <span aria-label="Next">›</span>
                  </button>
                </div>
                <div class="owl-dots">
                  <button role="button" class="owl-dot active">
                    <span></span>
                  </button>
                  <button role="button" class="owl-dot">
                    <span></span>
                  </button>
                </div>
              </carousel>
            </div>
          </div>
       
        </div>
      </div>
      <div class="container">
        <div class="main_contents">
          <div class="m_service_wrap">
            <div class="row">
              <div class="col-md-12 col-lg-6">
                <div class="m_app_box">
                  <div class="m_app_info">
                    <h4>Download Applications</h4>
                    <p>Get your <br />Windows &amp; Mobile Application</p>
                    <div class="app_link_box">
                      <router-link
                        :to="{
                          name: 'noticeDetail',
                          query: { boardId: 'c2438615b7f74c8d93f3839834bd23d7' },
                        }"
                        >Windows</router-link
                      >
                      <a target="_blank" class="app_android_icon" href="https://play.google.com/store/apps/details?id=com.hdi.heavy.gsismobile">
                      Android</a>
                      <a
                        href="https://apps.apple.com/us/app/doosanconnect-operation-manual/id1587647879"
                        class="app_ios_icon"
                        target="_blank"
                        >iOS</a
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12 col-lg-6">
                <div class="m_service_box">
                  <ul>
                    <li>
                      <router-link
                        to="/support/qna/form"
                        @click.native="saveComponentName('Q&A', 'Support')"
                        >Q&amp;A<span
                          >Please register<br />your questions here.</span
                        ></router-link
                      >
                    </li>
                    <li>
                      <router-link
                        to="/support/faq"
                        @click.native="saveComponentName('FAQ', 'Support')"
                        class="m_service_icon02"
                        >FAQ<span
                          >You can fine answer to your<br />frequently asked questions
                          here</span
                        ></router-link
                      >
                    </li>
                    <li>
                      <router-link
                        to="/support/contactus"
                        @click.native="saveComponentName('Contact Us', 'Support')"
                        class="m_service_icon03"
                        >Contact US<span>Contact the staff in charge</span></router-link
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div v-if="recentDocs.length != 0" class="m_c_title_box">
            <h3><span>Latest Release Document</span></h3>
          </div>
          <!-----------------Recent Document---------------------------------->
          <div
            v-if="recentDocs.length != 0"
            class="row row-cols-1 row-cols-md-1 row-cols-lg-3 gy-3 gy-md-3 gy-lg-5"
          >
            <div class="col" v-for="(item, index) in recentDocs" :key="`i-${index}`">
              <div class="m_manual_box">
                <span class="mm_cate">{{ item.docTitle }}</span>
                <p class="mm_name">
                  <a href="#">{{ item.doctypeName }}</a>
                </p>
                <div class="mm_nav">
                  <ul>
                    <li v-if="item.upperName != null">{{ item.upperName }}</li>
                    <li>{{ item.prodName }}</li>
                  </ul>
                </div>
                <div class="mm_bottom">
                  <span
                    >{{ item.publishedDate.substring(0, 4) }}-{{
                      item.publishedDate.substring(4, 6)
                    }}-{{ item.publishedDate.substring(6, 8) }}</span
                  >
                  <ul>
                    <li>
                      <a
                        v-if="item.authWebhelpYn == 'Y' && item.verNodeRef"
                        :href="
                          '/docview/model/lang/' +
                          item.verNodeRef.replace('workspace://SpacesStore/', '') +
                          '/index.html'
                        "
                        target="_blank"
                        class="webhelp_icon"
                        title="Web View"
                        >WebHelp</a
                      >
                      <a
                        v-else
                        class="webhelp_icon disabled_type text_cursor"
                        title="Web View"
                        >WebHelp</a
                      >
                    </li>
                    <li>
                      <a
                        v-if="item.authViewYn == 'Y' && item.fileNodeRef"
                        :href="
                          '/document/preview?noCache=' +
                          date +
                          '&uid=' +
                          item.fileNodeRef.replace('workspace://SpacesStore/', '')
                        "
                        target="_blank"
                        class="pdf_view_icon"
                        title="PDF View"
                        >View</a
                      >
                      <a
                        v-else
                        class="pdf_view_icon disabled_type text_cursor"
                        title="PDF View"
                        >View</a
                      >
                    </li>
                    <li>
                      <a
                        v-if="item.authDownloadYn == 'Y' && item.fileNodeRef"
                        @click="
                          pdfDownload(
                            item.fileNodeRef.replace('workspace://SpacesStore/', '')
                          )
                        "
                        class="pdf_down_icon"
                        title="PDF Download"
                        >PDF</a
                      >
                      <a
                        v-else
                        class="pdf_down_icon disabled_type text_cursor"
                        title="PDF Download"
                        >PDF</a
                      >
                    </li>
                    <li>
                      <a
                        v-if="item.authYn == 'Y'"
                        href="javascript:void(0)"
                        @click="showHistoryPopup(item.docId, item.docTitle)"
                        class="history_icon"
                        title="Version History"
                        >History</a
                      >
                      <a
                        v-else
                        class="history_icon disabled_type text_cursor"
                        title="Version History"
                        >History</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <!---------------------------------Notice  ------------------------->
          <div class="m_c_title_box m_bulletin_t">
            <h3>
              <span>{{ $t("common.notice") }}</span>
            </h3>
          </div>
          <div
            v-if="notice.length != 0"
            class="row row-cols-1 row-cols-md-1 row-cols-lg-3 gy-3 gy-md-3 gy-lg-5"
          >
            <div v-for="(item, index) in notice" :key="`j-${index}`" class="col">
              <div class="bulletin_box">
                <a href="javascript:void(0)">
                  <span class="bulletin_date_t"
                    >{{ item.firstRegDatetime.substring(2, 4)
                    }}<em>{{ item.firstRegDatetime.substring(5, 7) }}</em></span
                  >
                  <dl>
                    <dt>{{ item.title }}</dt>
                    <dd v-html="item.content"></dd>
                  </dl>
                  <em class="learn_link"
                    ><router-link
                      @click.native="saveComponentName('Notice', 'Support')"
                      :to="{ name: 'noticeDetail', query: { boardId: item.boardId } }"
                      >LEARN MORE</router-link
                    ></em
                  >
                </a>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

    <!--history 모달-->
    <HistoryModal
      id="historyModal"
      :docId="form.docId"
      :docTitle="docTitle"
      v-if="showModal"
      @close="showModal == false"
      ref="historyModal"
    >
      <template slot="footer">
        <button
          type="button"
          @click="closeModal"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          {{ $t("common.close") }}
        </button>
      </template>
    </HistoryModal>

    <MainPopup v-if="isPopupModalView == 'true'" @close="isPopupModalView = 'false'">
      <template slot="body"> </template>
      <template slot="footer">
        <div class="m-2">
           <!-- 팝업 사용시 주석 해제 -->
          <!-- <label for="popup"
            ><input name="popup" type="checkbox" @change="PopupNoDisplay" />
            {{ $t("common.dontShowForToday") }}
          </label> -->
        </div>
        <div></div>
        <div style="margin-right: 23px; margin-top: 10px">
          <button @click="isPopupModalView = 'false'">X</button>
        </div>
      </template>
    </MainPopup>
  </div>
</template>

<script>
import $ from "jquery";
import carousel from "vue-owl-carousel";
import { getNoticeList } from "@/api/notice";
import { getMainRecentDocument } from "@/api/search";
import { getMainQbar, preDownload } from "@/api/document";
import { getSearchSuggestList } from "@/api/search";
// 팝업 사용시 주석 해제
// import { savePopupNoDisplay, getPopupNoDisplay } from "@/utils/cookies";

import HistoryModal from "@/components/modal/HistoryModal";
import MainPopup from "@/components/MainPopup";

export default {
  components: {
    carousel,
    HistoryModal,
    MainPopup,
  },
  data() {
    return {
      searchWord: "",
      form: {
        page: 1,
        docId: "",
      },
      notice: "",
      recentDocs: "",
      prodQbarList: [],
      doctypeQbarList: [],
      prodQbarList2: [],
      doctypeQbarList2: [],
      showModal: false,
      isPopupModalView: "false",
      docTitle: "",
      date: new Date().toISOString(),
      suggestList : [],
      suggestShow : false,
      focusSearchInput : false,
      toggleCheck : true,
      scrollPostion : 0,
      arrowCounter: 0 ,
    };
  },
  created() {
    this.$root.$emit("initMenuClassActive");
    this.$session.set("label", "");
    this.fetchData();
    this.fetchMainQbar();
    this.fetchRecentDocument();
    // 팝업 사용시 주석 해제
    // this.isPopupModalView = getPopupNoDisplay();
    // if (this.isPopupModalView == "") {
    //   this.isPopupModalView = "true";
    // }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    goSearchPageOrSetSearchword() {
      // autocomplete 체크 및 검색
      let active = $(".is-active");
      if(active){
        let text = $(active).text();
        if(text){
          // 검색어 선택
          this.selectSuggest(text);
        }else{
          this.$router.push({ name: "pdf", query : {searchWord : this.searchWord },params: { searchWord: this.searchWord } });
        }
      }else{
        this.$router.push({ name: "pdf", query : {searchWord : this.searchWord },params: { searchWord: this.searchWord } });
      }
    },
    async fetchData() {
      try {
        // Notice
        const response = await getNoticeList(this.form);
        this.notice = response.data.pagingVO.dataList;
        if (this.notice.length > 3) {
          this.notice = this.notice.slice(0, 3);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async fetchRecentDocument() {
      try {
        // Notice
        const response = await getMainRecentDocument();
        this.recentDocs = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    saveComponentName(menuLabel, main) {
      this.$store.commit("setComponentName", menuLabel);
      this.$store.commit("setMainLabel", main);
    },
    showHistoryPopup(docId, docTitle) {
      this.form.docId = docId;
      this.docTitle = docTitle;
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
      this.form.docId = "";
      this.docTitle = "";
    },
    async fetchMainQbar() {
      try {
        const response = await getMainQbar();
        this.prodQbarList = response.data.prodQbarList;
        this.doctypeQbarList = response.data.doctypeQbarList;
        console.log(this.doctypeQbarList);
        this.prodQbarList2 = response.data.prodQbarList2;
        this.doctypeQbarList2 = response.data.doctypeQbarList2;
      } catch (error) {
        console.log(error);
      }
    },
    isFirst(index) {
      if (index == 0) return true;
      else return false;
    },
    async pdfDownload(uid) {
      let loader = this.$loading.show({});

      const response = await preDownload(uid);
      if (response.data.status) {
        loader.hide();
        window.open("/document/download/pdf?uid=" + uid);
      } else {
        loader.hide();
        alert("Download failed");
      }
    },
    // 검색어 autocomplete 이벤트1
    async getSuggestList(){
      try {
          const resp = await getSearchSuggestList(this.searchWord);
          if(resp!=null && resp.data.suggestList.length>0){
            this.suggestShow = true;
            this.suggestList = resp.data.suggestList;
            this.arrowCounter=-1;
          }else{
            this.suggestShow = false;
          }
      } catch (err) {
          console.log(err);
      }
    },
    // 검색어 autocomplete 이벤트2 (키보드 동작)
    onKeyEventActive(e){
      if (this.suggestList.length > 0) {
        if(e.code=="ArrowDown"){
          ++this.arrowCounter;
        }else{
          --this.arrowCounter;
        }
        if (this.arrowCounter >= this.suggestList.length)
          this.arrowCounter = (this.arrowCounter) % this.suggestList.length;
        else if (this.arrowCounter < 0)
          this.arrowCounter = this.suggestList.length + this.arrowCounter;
      }
    },
    // 검색어 autocomplete 이벤트3 (마우스 동작)
    onMouseEventActive(index){
      $(".autocomplete-li").removeClass("is-active");
      this.arrowCounter = index;
    },
    // 검색어 autocomplete 이벤트4 (자동완성 선택)
    selectSuggest(term){
      this.searchWord=term;
      this.suggestShow=false;
    },
    // Main page page up/down 이벤트
    scrollUpAndDown(){
      // 스크롤 맨 위로
      if (this.toggleCheck) {
        window.scrollTo(0,document.body.scrollHeight);
      // 스크롤 맨 아래로
      } else {
        window.scrollTo(0,0);
      }
    },
    handleScroll(){
      this.scrollPosition = document.documentElement.scrollTop;
      if(this.scrollPosition > 100){
        this.toggleCheck = false;
      } else {
        this.toggleCheck = true;
      }
    }
    // 팝업 사용시 주석 해제
    // 하루동안 팝업 보이지 않기
    // PopupNoDisplay() {
    //   this.isPopupModalView = "false";
    //   savePopupNoDisplay();
    // },
  },
};
</script>

<style scoped>
.autocomplete-ul{
    width: 510px;
    background: white;
    margin-top: 1px;
    position: absolute;
    z-index: 1000;
    /* height: 200px;
    overflow: auto; */
}
.autocomplete-li{
    padding: 10px;
}

.is-active {
  background-color: #f2faff;
}



</style>
